module.exports = __webpack_public_path__ + "static/media/line1.5bacc112.png";